import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

/** Quando presente no localStorage, o modal não reaparece até o próximo login (flag limpa no login e no logout). */
export const VIDE_ALERT_DIALOG_DISMISSED_KEY = 'ratoeira-vide-alert-dialog-dismissed';

export const VIDE_ALERT_DIALOG_PANEL_CLASS = 'vide-alert-dialog-panel';

// const EMBED_URL = 'https://www.youtube.com/embed/tuYcZztCv94?si=j745DvHEoPPtxUZe'; // VIDEO DIRECT TO CHECKOUT CLICKBANK
// const EMBED_URL = 'https://www.youtube.com/embed/kUYkOy0hP9s?si=_MujXZPPluhcLP9C'; // VIDEO DASH FINANCEIRO
// const EMBED_URL = 'https://www.youtube.com/embed/0rPkmL9m0Iw?si=axSfWAGpz0Je_iqe'; // VIDEO GERENCIADOR
const EMBED_URL = 'https://www.youtube.com/embed/61Cc1vxfl5U?si=7dZx0QeuzcHS1kOt'; // VIDEO GERENCIADOR

export function isVideAlertDialogDismissed(): boolean {
    if (typeof localStorage === 'undefined') return false;
    return localStorage.getItem(VIDE_ALERT_DIALOG_DISMISSED_KEY) === '1';
}

/** Chame após login bem-sucedido ou no logout para o vídeo voltar a ser oferecido no próximo acesso autenticado. */
export function clearVideAlertDialogDismissedFlag(): void {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(VIDE_ALERT_DIALOG_DISMISSED_KEY);
}

/** Abre o modal se ainda não houver `VIDE_ALERT_DIALOG_DISMISSED_KEY` no localStorage. Aplica o `panelClass` esperado em `styles.scss`. */
export function openVideAlertDialogIfNeeded(dialog: MatDialog): MatDialogRef<VideAlertDialogComponent> | null {
    if (isVideAlertDialogDismissed()) {
        return null;
    }
    return dialog.open(VideAlertDialogComponent, {
        panelClass: VIDE_ALERT_DIALOG_PANEL_CLASS,
        autoFocus: false,
        restoreFocus: false,
    });
}

@Component({
    selector: 'app-vide-alert-dialog',
    standalone: true,
    imports: [MatIconButton, MatIcon, CommonModule],
    templateUrl: './vide-alert-dialog.component.html',
    styleUrl: './vide-alert-dialog.component.scss',
})
export class VideAlertDialogComponent {
    videoUrl: SafeResourceUrl;

    constructor(
        private dialogRef: MatDialogRef<VideAlertDialogComponent>,
        private sanitizer: DomSanitizer,
    ) {
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(EMBED_URL);
        this.dialogRef.afterClosed().subscribe(() => {
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem(VIDE_ALERT_DIALOG_DISMISSED_KEY, '1');
            }
        });
    }

    fechar(): void {
        this.dialogRef.close();
    }
}
